<template>
    <div class="play-btn relative w-full h-full">
        <button class="w-full h-full flex items-center justify-center cursor-pointer" @click="togglePlay" tabindex="0"
            :aria-label="isPlaying ? 'Metti in pausa il video' : 'Riproduci il video'" role="button">
            <!-- Stop icon -->
            <svg v-if="isPlaying" class="h-5 w-5 text-black block scale-[1.04]" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_7368_4418)">
                    <path d="M23.3333 16V40H21.3333V16H23.3333Z" fill="currentColor"/>
                    <path d="M31.3333 16V40H29.3333V16H31.3333Z" fill="currentColor"/>
                </g>
                <defs>
                    <clipPath id="clip0_7368_4418">
                        <rect width="10.6667" height="24" fill="white" transform="translate(21 16)"/>
                    </clipPath>
                </defs>
            </svg>
            <!-- Play icon -->
            <svg v-else class="h-5 w-5 text-black block scale-[1.04]" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3333 16.3333H22.3333L36.3333 26.8333V29.1667L22.3333 39.6667H18.3333V16.3333ZM20.3333 18.3333V37.6667H21.6667L34.3333 28.1667V27.8333L21.6667 18.3333H20.3333Z" fill="currentColor"/>
            </svg>
        </button>
        <div
            class="play-tooltip text-3xs absolute left-0 top-1/2 p-2 bg-black text-white w-max -translate-x-full -translate-y-1/2 -left-3">
            {{ isPlaying ? 'Stop Video' : 'Play Video' }}
        </div>
        <div
            class="play-tooltip-arrow absolute left-0 top-1/2 w-0 h-0 border-y-[7px] border-r-0 border-l-8 border-transparent border-l-black -translate-x-full -translate-y-1/2 -left-1">
        </div>
    </div>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
    props:{
        isPlaying:{
            type: Boolean,
            required: true
        },
        togglePlay:{
            type: Function,
            required: true
        }
    },
})
</script>
<style scoped>

.play-btn .play-tooltip,
.play-btn .play-tooltip-arrow{
    display: none;
}
.play-btn:hover .play-tooltip,
.play-btn:hover .play-tooltip-arrow{
    display: block;
}
</style>